module.exports = "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/BannerRightArrow.a129e3c8.svg";